import React from 'react';
import { Combobox, createDefaultControl } from "../Combobox";
import { createDefaultOption } from "../../Suggest";
import { CONTROL_SIZE } from "../../common/public";
export function searchCategoryAddon(_a) {
    var value = _a.value, options = _a.options, onChange = _a.onChange, _b = _a.size, size = _b === void 0 ? CONTROL_SIZE.xs : _b;
    return function searchCategoryRenderer(_a) {
        var disabled = _a.disabled, blur = _a.blur;
        return (React.createElement(Combobox, { "data-selector-id": 'search-category', value: value, data: options, disabled: disabled, valueGetter: function (item) { return item.value; }, textGetter: function (item) { return item.text; }, controlRenderer: createDefaultControl({
                buildIn: true,
                iconGetter: function (_a) {
                    var option = _a.option;
                    var _b;
                    return (_b = option === null || option === void 0 ? void 0 : option.icon) !== null && _b !== void 0 ? _b : null;
                }
            }), optionRenderer: createDefaultOption({
                iconGetter: function (_a) {
                    var option = _a.option;
                    var _b;
                    return (_b = option === null || option === void 0 ? void 0 : option.icon) !== null && _b !== void 0 ? _b : null;
                }
            }), onChange: onChange, size: size > CONTROL_SIZE.l ? CONTROL_SIZE.l : size, onBlur: blur }));
    };
}
//# sourceMappingURL=searchCategoryAddon.js.map